/** Valeurs persistées (Organization.professionType). */
export const PROFESSION_TYPES = [
  "GENERIC",
  "FITNESS_COACH",
  "PSYCHOLOGIST",
  "BUSINESS_COACH",
  "NUTRITIONIST",
  "SOPHROLOGIST",
] as const;

export type ProfessionType = (typeof PROFESSION_TYPES)[number];

/** Clé i18n `settings.*` pour chaque option du sélecteur métier. */
export const professionSelectLabelKey = (
  professionType: ProfessionType,
): string => {
  const keys: Record<ProfessionType, string> = {
    GENERIC: "settings.professionGeneric",
    FITNESS_COACH: "settings.professionFitness",
    PSYCHOLOGIST: "settings.professionPsychologist",
    BUSINESS_COACH: "settings.professionBusiness",
    NUTRITIONIST: "settings.professionNutritionist",
    SOPHROLOGIST: "settings.professionSophrologist",
  };
  return keys[professionType];
};

/** Clé i18n `settings.*` pour afficher le métier hors mode « Générique + libellé perso ». */
export const settingsProfessionTranslationKey = (
  professionType: string,
): string | null => {
  const m: Record<string, string> = {
    FITNESS_COACH: "settings.professionFitness",
    PSYCHOLOGIST: "settings.professionPsychologist",
    BUSINESS_COACH: "settings.professionBusiness",
    NUTRITIONIST: "settings.professionNutritionist",
    SOPHROLOGIST: "settings.professionSophrologist",
  };
  return m[professionType] ?? null;
};

/** Clé i18n `portal.*` pour l’espace client. */
export const portalProfessionTranslationKey = (
  professionType: string,
): string | null => {
  const m: Record<string, string> = {
    FITNESS_COACH: "portal.fitnessCoach",
    PSYCHOLOGIST: "portal.psychologist",
    BUSINESS_COACH: "portal.businessCoach",
    NUTRITIONIST: "portal.nutritionist",
    SOPHROLOGIST: "portal.sophrologist",
  };
  return m[professionType] ?? null;
};
